export interface SignupRequestType {
  email: string;
  password: string;
}

export type SignupResponseType = string;
export const signupRequestUrl = '/authentication/signup';

export interface ResendCodeRequestType {
  email: string;
}
export type ResendCodeResponseType = string;
export const resendCodeRequestUrl = '/authentication/resendCode';

export interface SigninRequestType {
  email: string;
  password: string;
}
export interface SigninResponseType {
  isConnected: boolean;
  hasDoubleAuth?: boolean;
  roles: Role[];
}
export const signinRequestUrl = '/authentication/signin';

export type SessionStatusResponseType = {
  isConnected: boolean;
  hasDoubleAuth: boolean | null;
  refreshed?: boolean; // Indique si les tokens ont été automatiquement rafraîchis
  // Absent quand la session est fermée : le contrôleur répond alors sans rôles.
  roles?: Role[];
};
export const sessionStatusRequestUrl = '/authentication/session/status';

export type RevokeRequestType = {
  refreshToken: string;
};
export type RevokeResponseType = { message: string };

export const revokeRequestUrl = '/authentication/revoke';

export type RefreshResponseType = {
  isConnected: boolean;
  accessToken: string;
  idToken: string;
  roles: Role[];
};

export const refreshRequestUrl = '/authentication/refresh';

export type ForgotPasswordRequestType = {
  email: string;
};
export type ForgotPasswordResponseType = string;
export const forgotPasswordRequestUrl = '/authentication/forgotPassword';

export type ConfirmForgotPasswordRequestType = {
  email: string;
  password: string;
  code: string;
};

export type ConfirmForgotPasswordResponseType = string;
export const configForgotPasswordRequestUrl =
  '/authentication/confirmForgotPassword';

export const Role = {
  ADH_ADMIN: 'ADH_ADMIN',
  ENDYA: 'ENDYA',
  ENDYA_ADMIN: 'ENDYA_ADMIN',
} as const;
export type Role = (typeof Role)[keyof typeof Role];

export const UNAUTHORIZED_APP_ACCESS = 'UNAUTHORIZED_APP_ACCESS';

export type ConfirmRequestType = {
  email: string;
  code: string;
};

export const confirmUrl = '/authentication/confirm';

export const changePasswordUrl = '/authentication/changePassword';
export interface ChangePasswordType {
  previousPassword: string;
  proposedPassword: string;
}
export const newPasswordUrl = '/authentication/newPassword';
export interface NewPasswordType {
  userId: string;
  session: string;
  password: string;
}

export interface SendDoubleAuthCodeType {
  code: string;
}

export const sendDoubleAuthCodeUrl = '/authentication/sendDoubleAuthCode';

export type SendDoubleAuthCodeResponseType = {
  value: boolean;
  remainingAttempts: number;
};
export interface DeleteUserByAdminSystemType {
  email: string;
}

export type AuthenticationCookiesType = {
  accessToken: string;
  refreshToken: string;
  idToken: string;
};
